import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'letter-x-small', 'LetterXSmall', [["path",{"d":"M10 8l4 8"}],["path",{"d":"M10 16l4 -8"}]]);